import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
import styles from './audio-player.component.module.scss';
interface Props {
  readonly src: string;
}
let currentPlayingAudio: HTMLAudioElement | null = null;
const AudioPlayerComponent: React.FC<Props> = t0 => {
  const $ = _c(15);
  const {
    src
  } = t0;
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const audioElement = audioRef.current;
      if (audioElement) {
        const stopPlaying = () => {
          setIsPlaying(false);
          if (currentPlayingAudio === audioElement) {
            currentPlayingAudio = null;
          }
        };
        audioElement.addEventListener("ended", stopPlaying);
        audioElement.addEventListener("pause", stopPlaying);
        return () => {
          audioElement.removeEventListener("ended", stopPlaying);
          audioElement.removeEventListener("pause", stopPlaying);
        };
      }
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== isPlaying) {
    t3 = () => {
      const audioElement_0 = audioRef.current;
      if (audioElement_0) {
        if (isPlaying) {
          audioElement_0.pause();
          setIsPlaying(false);
        } else {
          if (currentPlayingAudio && currentPlayingAudio !== audioElement_0) {
            currentPlayingAudio.pause();
          }
          audioElement_0.play();
          currentPlayingAudio = audioElement_0;
          setIsPlaying(true);
        }
      }
    };
    $[2] = isPlaying;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const togglePlay = t3;
  let t4;
  if ($[4] !== src) {
    t4 = <audio ref={audioRef} src={src} preload="none" />;
    $[4] = src;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `/assets/icons/${isPlaying ? "pause" : "play"}_circle.svg`;
  const t6 = `${isPlaying ? "pause" : "play"} icon`;
  let t7;
  if ($[6] !== t5 || $[7] !== t6) {
    t7 = <ImageComponent src={t5} alt={t6} height={24} width={24} />;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7 || $[10] !== togglePlay) {
    t8 = <button onClick={togglePlay} className={styles["audio-player__button"]}>{t7}</button>;
    $[9] = t7;
    $[10] = togglePlay;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t4 || $[13] !== t8) {
    t9 = <div className={styles["audio-player"]}>{t4}{t8}</div>;
    $[12] = t4;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
export default AudioPlayerComponent;